import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabfrompunetomahabaleshwar() {



  const cardData =
  {
    keyword: 'Cab from Pune to Mahabaleshwar',
    heading: 'Aaryan Travels: Cab from Pune to Mahabaleshwar',
    headingDescription: ' Aaryan Travels offers reliable Cab from Pune to Mahabaleshwar for travelers seeking a comfortable journey to one of Maharashtra’s most popular hill stations. Whether it’s a weekend getaway, family trip, or honeymoon tour, our well-maintained sedans, SUVs, and luxury cars ensure a smooth ride through the scenic ghats. With courteous drivers familiar with local routes and sightseeing spots like Venna Lake, Mapro Garden, Arthur Seat Point, and Pratapgad Fort, we make your travel enjoyable and stress-free. Enjoy flexible pickup options from any location in Pune, transparent fares, and round-trip or one-way cab booking with 24/7 availability. Aaryan Travels guarantees a safe and memorable ride to Mahabaleshwar at the best price.',

    top: 'Top Places to Visit in Mahabaleshwar with Aaryan Travels',

  "topPlaces": [
  {
    "title": "Arthur’s Seat",
    "description": "Arthur’s Seat is known as the ‘Queen of All Points’ in Mahabaleshwar, offering breathtaking views of the deep Savitri Gorge on one side and dense valleys on the other. It is famously compared to the Grand Canyon of India due to its layered rock formations. Adventure enthusiasts and photographers flock here for sunrise and sunset vistas. The cool breeze and misty atmosphere add to its charm. Arthur’s Seat is Mahabaleshwar’s most spectacular viewpoint."
  },
  {
    "title": "Venna Lake",
    "description": "Venna Lake is a serene man-made lake surrounded by lush greenery and forested hills. Tourists enjoy boating, horse riding, and lakeside snacks like corn and strawberries. The peaceful waters reflect the beauty of Mahabaleshwar’s misty skies. It becomes especially lively during evenings as families stroll along the illuminated banks. Venna Lake is Mahabaleshwar’s favorite leisure escape."
  },
  {
    "title": "Mapro Garden",
    "description": "Mapro Garden is a delightful attraction famous for its strawberry-based products, chocolate factory, and beautifully landscaped seating areas. Visitors relish fresh strawberry cream, pizzas, and mocktails at the open café. The garden also hosts the iconic Strawberry Festival every year. Lush greenery and floral décor make it a scenic hangout spot. Mapro Garden is Mahabaleshwar’s sweet paradise for food lovers."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point is a stunning rock formation that resembles the head and trunk of an elephant. Surrounded by deep valleys and cool winds, it is one of the most photographed spots in Mahabaleshwar. The viewpoint offers a peaceful environment for nature lovers. Clouds often drift close, giving a heavenly feel. Elephant’s Head Point is Mahabaleshwar’s natural masterpiece."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort is a historic hill fort built by Chhatrapati Shivaji Maharaj in 1656. It is renowned for the legendary battle between Shivaji Maharaj and Afzal Khan. Visitors explore its watchtowers, temples, and cannons while enjoying panoramic views of the Konkan region. The fort’s architecture reflects Maratha valor and strategic brilliance. Pratapgad is Mahabaleshwar’s proud symbol of history and courage."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall cascades down from a great height amid lush forests, creating a mesmerizing sight. There are two viewpoints — a small waterfall ideal for bathing and a massive main fall perfect for photography. Monsoon transforms it into a roaring spectacle with misty surroundings. Trekking paths enhance the adventure. Lingmala Waterfall is Mahabaleshwar’s refreshing monsoon wonder."
  },
  {
    "title": "Wilson Point (Sunrise Point)",
    "description": "Wilson Point is the highest point in Mahabaleshwar and the best place to witness sunrise. The vast plateau offers 360-degree views of hills, valleys, and fog-laden landscapes. Early risers enjoy the golden hues spreading across the sky. It is also ideal for star-gazing at night. Wilson Point is Mahabaleshwar’s majestic summit of serenity."
  },
  {
    "title": "Panchgani Table Land",
    "description": "Table Land in nearby Panchgani is Asia’s second-largest volcanic plateau, offering vast flat land at a high altitude. Tourists enjoy horse cart rides, cave visits, and cinematic views of the surrounding valleys. Several Bollywood films have been shot here. It is perfect for panoramic photography and leisure walks. Table Land is Mahabaleshwar’s grand natural playground."
  },
  {
    "title": "Mahabaleshwar Temple",
    "description": "Mahabaleshwar Temple is an ancient shrine dedicated to Lord Shiva, believed to house a self-originated lingam. Built in Hemadpanti architecture, the temple is revered by pilgrims and history enthusiasts. The peaceful ambiance and surrounding forests enhance its spiritual aura. Rituals and festivals draw devotees year-round. Mahabaleshwar Temple is the divine heart of the hill station."
  },
  {
    "title": "Kate’s Point and Needle Hole Point",
    "description": "Kate’s Point offers impressive views of the Krishna Valley and the Dhom Dam waters below. A nearby rock formation called Needle Hole Point resembles a naturally carved hole, adding thrill to photography. Cool winds and dramatic cliffs make it a favorite among couples and trekkers. The viewpoint is easily accessible and scenic throughout the year. Kate’s Point is Mahabaleshwar’s picturesque cliffside retreat."
  }
],


  "services": [
  {
    "name": "Cab from Pune to Mahabaleshwar",
    "description": "Experience a comfortable and scenic journey with our Cab service from Pune to Mahabaleshwar. Whether you're traveling for a weekend getaway or a family trip, our well-maintained vehicles and professional drivers ensure a safe and relaxing ride. Enjoy hassle-free bookings, flexible timings, and competitive pricing for a memorable travel experience to this beautiful hill station."
  },
  {
    "name": "Pune to Mahabaleshwar Taxi",
    "description": "Our Pune to Mahabaleshwar Taxi service offers reliable and punctual transportation to the lush greenery and cool climate of Mahabaleshwar. Ideal for tourists and locals alike, our taxis are equipped with comfortable seating, experienced drivers, and are available for one-way or round trips. Make your journey stress-free with timely pickups and drop-offs."
  },
  {
    "name": "Outstation Cab Pune Mahabaleshwar",
    "description": "Travel beyond city limits with our Outstation Cab service from Pune to Mahabaleshwar. Perfect for leisure travelers and nature enthusiasts, this service provides spacious vehicles, flexible rental durations, and knowledgeable drivers familiar with the best routes and attractions. Enjoy door-to-door service with transparent fares and 24/7 support."
  },
  {
    "name": "Pune Mahabaleshwar Car Rental",
    "description": "Rent cars for your Pune to Mahabaleshwar trip with ease through our car rental service. Choose from a wide range of sedans, SUVs, and premium vehicles to suit your travel needs. Whether self-drive or chauffeur-driven, our rentals come with full insurance coverage, timely service, and affordable packages tailored for your vacation or business trips."
  },
  {
    "name": "Affordable Taxi Pune Mahabaleshwar",
    "description": "Get the best value with our Affordable Taxi services from Pune to Mahabaleshwar, offering budget-friendly rates without compromising on comfort or safety. Suitable for solo travelers, families, and groups, this service ensures clean vehicles, courteous drivers, and prompt pickups, making your journey economical and enjoyable."
  },
  {
    "name": "Sedan Cab Pune to Mahabaleshwar",
    "description": "Choose our Sedan Cab option for a smooth and comfortable ride from Pune to Mahabaleshwar. Perfect for small groups and business travelers, our sedans are well-maintained, air-conditioned, and driven by experienced chauffeurs who prioritize your safety and convenience throughout the trip."
  },
  {
    "name": "SUV Hire Pune Mahabaleshwar",
    "description": "For larger groups or those seeking more space, our SUV Hire service from Pune to Mahabaleshwar offers roomy and comfortable vehicles. With ample luggage capacity and powerful performance, our SUVs are ideal for family trips and outdoor adventures. Professional drivers ensure a safe and enjoyable journey through scenic routes."
  },
  {
    "name": "Best Pune Mahabaleshwar Cab",
    "description": "Experience the Best Cab service from Pune to Mahabaleshwar with top-notch customer support, punctuality, and premium vehicles. Our service is designed to cater to all your travel needs, providing luxury options, flexible booking, and transparent pricing for a hassle-free and memorable trip to the hills."
  },
  {
    "name": "Pune to Mahabaleshwar Tour Cab",
    "description": "Explore the beauty of Mahabaleshwar with our specialized Tour Cab service from Pune. Our knowledgeable drivers can guide you through popular tourist spots, making stops at key attractions while ensuring comfortable travel. Customize your itinerary and enjoy a relaxed, scenic tour tailored to your preferences."
  },
  {
    "name": "AC Cab Pune Mahabaleshwar",
    "description": "Stay cool and comfortable throughout your journey with our AC Cab service from Pune to Mahabaleshwar. All vehicles are equipped with efficient air conditioning systems, clean interiors, and professional drivers focused on providing a smooth, refreshing travel experience regardless of the weather."
  },
  {
    "name": "Pune to Mahabaleshwar Cab Booking",
    "description": "Book your Pune to Mahabaleshwar cab easily through our online platform or customer service. Enjoy instant confirmations, flexible payment options, and the ability to schedule rides in advance. Our streamlined booking process ensures you get the best cab for your travel dates and preferences without any hassle."
  },
  {
    "name": "Round Trip Cab Pune Mahabaleshwar",
    "description": "Make the most of your trip with our Round Trip Cab service between Pune and Mahabaleshwar. Conveniently book a cab for both onward and return journeys with fixed pricing and guaranteed vehicle availability. Perfect for weekend getaways and extended vacations, this service provides peace of mind and comfort throughout your travel."
  },
  {
    "name": "Online Cab Pune Mahabaleshwar",
    "description": "Our Online Cab Booking platform for Pune to Mahabaleshwar offers a user-friendly experience with instant booking, fare transparency, and multiple payment options. Schedule your trip from the comfort of your home or office and enjoy real-time tracking and customer support for a stress-free travel experience."
  },
  {
    "name": "Weekend Cab Pune Mahabaleshwar",
    "description": "Plan your perfect weekend getaway with our Weekend Cab service from Pune to Mahabaleshwar. Tailored for short trips, this service offers flexible timing, comfortable vehicles, and knowledgeable drivers who ensure timely arrivals and departures so you can maximize your leisure time in the serene hills."
  },
  {
    "name": "Mahabaleshwar Trip Cab Pune",
    "description": "Make your Mahabaleshwar trip memorable with our dedicated cab services from Pune. Whether you’re visiting for sightseeing, relaxation, or adventure, we provide reliable transportation options with experienced drivers, clean vehicles, and personalized service to make your journey enjoyable and hassle-free."
  }
],
"tableData": [
  ["Cab from Pune to Mahabaleshwar", "Pune to Mahabaleshwar Taxi"],
  ["Outstation Cab Pune Mahabaleshwar", "Pune Mahabaleshwar Car Rental"],
  ["Affordable Taxi Pune Mahabaleshwar", "Sedan Cab Pune to Mahabaleshwar"],
  ["SUV Hire Pune Mahabaleshwar", "Best Pune Mahabaleshwar Cab"],
  ["Pune to Mahabaleshwar Tour Cab", "AC Cab Pune Mahabaleshwar"],
  ["Pune to Mahabaleshwar Cab Booking", "Round Trip Cab Pune Mahabaleshwar"],
  ["Online Cab Pune Mahabaleshwar", "Weekend Cab Pune Mahabaleshwar"],
  ["Mahabaleshwar Trip Cab Pune", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Trusted Cab Service from Pune to Mahabaleshwar",
    "WhyChoosedescription": "Aaryan Travels offers reliable and comfortable cab services for your Pune to Mahabaleshwar journey."
  },
  {
    "WhyChooseheading": "Convenient Pickup from Any Location in Pune",
    "WhyChoosedescription": "Our drivers are ready to pick you up from your preferred spot in Pune for a hassle-free start to your trip."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Vehicles for Scenic Rides",
    "WhyChoosedescription": "Travel in sanitized, air-conditioned vehicles ensuring a relaxing journey to Mahabaleshwar."
  },
  {
    "WhyChooseheading": "Experienced Drivers Familiar with Pune-Mahabaleshwar Routes",
    "WhyChoosedescription": "Our drivers know the best routes to take you swiftly and safely to your hill station destination."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "Enjoy upfront pricing covering tolls, fuel, and driver allowances with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support for Easy Booking",
    "WhyChoosedescription": "Our support team is available round the clock to assist you with bookings and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Booking for One-Way or Round Trips",
    "WhyChoosedescription": "Choose from one-way rides or round trips based on your travel plans to Mahabaleshwar."
  },
  {
    "WhyChooseheading": "Vehicle Options to Suit Solo Travelers and Groups",
    "WhyChoosedescription": "Select from sedans, SUVs, or tempo travellers to match your group size and luggage requirements."
  }
]



























  }

const faqData = [
  {
    question: 'Does Aaryan Travels offer cab services from Pune to Mahabaleshwar?',
    answer: 'Yes, Aaryan Travels provides reliable and comfortable cab services for travel from Pune to Mahabaleshwar.',
  },
  {
    question: 'How can I book a cab from Pune to Mahabaleshwar with Aaryan Travels?',
    answer: 'You can book your cab easily through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for Pune to Mahabaleshwar cab bookings?',
    answer: 'We offer a variety of vehicles including hatchbacks, sedans, SUVs, and premium cars to suit your travel needs.',
  },
  {
    question: 'Are cabs available for one-way and round trips between Pune and Mahabaleshwar?',
    answer: 'Yes, Aaryan Travels offers both one-way and round-trip cab services for Pune to Mahabaleshwar travel.',
  },
  {
    question: 'Are the drivers experienced with the Pune-Mahabaleshwar route?',
    answer: 'Absolutely. Our drivers are licensed professionals and familiar with the Pune to Mahabaleshwar route for a safe and comfortable journey.',
  },
  {
    question: 'Can I book hourly or full-day packages for Pune to Mahabaleshwar travel?',
    answer: 'Yes, we offer flexible hourly and full-day rental packages to suit your travel plans.',
  },
  {
    question: 'What safety and hygiene measures are followed for Pune to Mahabaleshwar cab services?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety protocols to ensure passenger safety.',
  },
  {
    question: 'Is Aaryan Travels cab booking service from Pune to Mahabaleshwar available 24x7?',
    answer: 'Yes, our booking and cab services are available round the clock for Pune to Mahabaleshwar travel.',
  },
  {
    question: 'What payment options are accepted for Pune to Mahabaleshwar cab bookings?',
    answer: 'We accept cash, credit/debit cards, UPI, and popular digital wallets for seamless payments.',
  },
  {
    question: 'Can I customize pickup and drop-off locations for Pune to Mahabaleshwar cab bookings?',
    answer: 'Yes, Aaryan Travels allows you to specify preferred pickup and drop points for your trip from Pune to Mahabaleshwar.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Manoj Joshi',
    feedback: 'Aaryan Travels made our Pune to Mahabaleshwar trip enjoyable with their punctual and comfortable cab service.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Ritu Patil',
    feedback: 'Excellent service from Aaryan Travels on our Pune to Mahabaleshwar journey. The driver was friendly and knowledgeable.',
    rating: 5,
  },
];
















































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Best Cab Services in Pune", link: "best-cab-services-in-pune" },
    { place: "/images/keyword/3.jpg", text: "Best Cab Services in Kochi", link: "best-cab-services-in-kochi" },
    { place: "/images/keyword/4.jpg", text: "Cab booking from Mumbai to Pune", link: "cab-booking-from-mumbai-to-pune" },
    { place: "/images/keyword/5.jpg", text: "Cab from Pune to Mahabaleshwar", link: "cab-from-pune-to-mahabaleshwar" },
    { place: "/images/keyword/6.jpg", text: "Monthly Cab hire contract in Hyderabad", link: "monthly-cab-hire-contract-in-hyderabad" },
    { place: "/images/keyword/7.jpg", text: "Taxi Services from Pune to Shirdi", link: "taxi-services-from-pune-to-shirdi" },
    { place: "/images/keyword/8.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Pune Corporate Cab", link: "mumbai-to-pune-corporate-cab" },
    { place: "/images/keyword/10.jpg", text: "Outstation Cab Services from Pune", link: "outstation-cab-services-from-pune" },
    { place: "/images/keyword/11.jpg", text: "Innova Crysta rental in Pune", link: "innova-crysta-rental-in-pune" },
    { place: "/images/keyword/12.jpg", text: "Corporate Cab hire in Pune", link: "corporate-cab-hire-in-pune" },
    { place: "/images/keyword/13.jpg", text: "Pune to Shirdi Corporate Cab booking", link: "pune-to-shirdi-corporate-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Corporate Cab Services", link: "pune-to-mumbai-corporate-cab-services" },
    { place: "/images/keyword/15.jpg", text: "Monthly Corporate Cab rental in Chennai", link: "monthly-corporate-cab-rental-in-chennai" },
    { place: "/images/keyword/16.jpg", text: "Wedding Corporate Cab bookings in Pune", link: "wedding-cab-bookings-in-pune" },
    { place: "/images/keyword/17.jpg", text: "Corporate Cab Services in Kharadi, Pune", link: "corporate-cab-services-in-kharadi-pune" },
    { place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranchi", link: "corporate-cab-services-in-ranchi" },
    { place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Vadodara", link: "corporate-cab-services-in-vadodara" },
    { place: "/images/keyword/20.jpg", text: "Corporate Cab booking in Ranchi", link: "corporate-cab-booking-in-ranchi" },
    { place: "/images/keyword/21.jpg", text: "Corporate Cab booking in Vadodara", link: "corporate-cab-booking-in-vadodara" },
    { place: "/images/keyword/22.jpg", text: "Taxi booking in Ranchi", link: "taxi-booking-in-ranchi" },
    { place: "/images/keyword/23.jpg", text: "Corporate Cab Services in India", link: "corporate-cab-services-in-india" },
    { place: "/images/keyword/24.jpg", text: "Taxi Services in Vadodara, Gujarat", link: "taxi-services-in-vadodara-gujarat" },
    { place: "/images/keyword/25.jpg", text: "Taxi booking in Vadodara", link: "taxi-booking-in-vadodara" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Cab from Pune to Mahabaleshwar",
  "image": "https://aaryantravels.com/assets/images/pune-mahabaleshwar-cab.jpg", // replace with actual image URL
  "description": "Affordable and reliable cab service from Pune to Mahabaleshwar. Choose from AC sedans, SUVs, and round-trip options for your weekend trips and tours. Book online with Aaryan Travels for a comfortable journey.",
  "brand": {
    "@type": "Brand",
    "name": "Aaryan Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",  // example rating, update as needed
    "ratingCount": "4200", // example rating count, update as needed
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1800",  // example price, adjust as needed
    "availability": "https://schema.org/InStock",
    "url": "https://aaryantravels.com/cab-pune-mahabaleshwar"
  }
};






  return (
    <div>


<Helmet>
  <title>Cab from Pune to Mahabaleshwar | Affordable & Reliable Taxi | Aaryan Travels</title>
  <meta
    name="description"
    content="Affordable and reliable cab service from Pune to Mahabaleshwar. Choose from AC sedans, SUVs, and round-trip options for your weekend trips and tours. Book online with Aaryan Travels for a comfortable journey."
  />
  <meta
    name="keywords"
    content="Cab from Pune to Mahabaleshwar, Pune to Mahabaleshwar Taxi, Outstation Cab Pune Mahabaleshwar, Pune Mahabaleshwar Car Rental, Affordable Taxi Pune Mahabaleshwar, Sedan Cab Pune to Mahabaleshwar, SUV Hire Pune Mahabaleshwar, Best Pune Mahabaleshwar Cab, Pune to Mahabaleshwar Tour Cab, AC Cab Pune Mahabaleshwar, Pune to Mahabaleshwar Cab Booking, Round Trip Cab Pune Mahabaleshwar, Online Cab Pune Mahabaleshwar, Weekend Cab Pune Mahabaleshwar, Mahabaleshwar Trip Cab Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box">
                <h1 className="text-anime-style-3" data-cursor="-opaque">
                   {cardData.keyword}
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>










      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/5.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Aaryan Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Aaryan Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919730707888" className="pc-call">+91 9730707888</a>
                      <a href="tel:+919833377051" className="pc-call">+91 9833377051</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919730707888"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919730707888" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:bookings@aaryantravels.com" className="pc-email">
                      bookings@aaryantravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Aryan Travels Pune Head Office</strong><br />
                      Flat 304, Plot-82, Prathmesh Krupa, Purnanagar/Chikhali Pune- 411019.
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Cabfrompunetomahabaleshwar;